import { IRegionTransaction, ITransaction } from '@/types/explorer';
import { normalizeUsername } from '@/utils/strings';
import { apiCall } from '@/utils/api';

export const getTransactions = async (limit = 100, skip = 0, username = '') => {
  const TRANSACTIONS_ROUTE = '/transactions/rewards';
  try {
    const response: { transactions: ITransaction[] } = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${TRANSACTIONS_ROUTE}/${normalizeUsername(
        username,
      )}?limit=${limit}&skip=${skip}`,
      {
        method: 'GET',
      },
    );
    return response.transactions;
  } catch (error) {
    return [];
  }
};

export const getRegionTransactions = async (
  region: string,
  limit = 100,
  skip = 0,
) => {
  const TRANSACTIONS_ROUTE = '/transactions/region';
  try {
    if (!region) throw new Error('No region specified');
    const response: { transactions: IRegionTransaction[] } = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${TRANSACTIONS_ROUTE}/${region}?limit=${limit}&skip=${skip}`,
      {
        method: 'GET',
      },
    );
    return response.transactions;
  } catch (error) {
    console.log(error);
    return [];
  }
};
